import { useEffect, useRef, useState } from 'react'
import './AudioBadge.scss'

const AudioBadge = ({ audioSource, setTimeEstimation }) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = useRef()

  useEffect(() => {
    const audioRefEffect = audioRef.current
    audioRefEffect.onloadedmetadata = () => {
      setTimeEstimation(Math.round(audioRefEffect.duration / 60))
    }
  }, [setTimeEstimation, audioRef])

  useEffect(() => {
    const audioRefEffect = audioRef.current
    audioRefEffect.addEventListener('ended', () => audioRefEffect.pause())
    return () => {
      audioRefEffect.removeEventListener('ended', () => audioRefEffect.pause())
    }
  }, [])

  const handleTogglePlay = () => {
    if (audioRef.current.paused) {
      audioRef.current.play()
    } else {
      audioRef.current.pause()
      audioRef.current.load()
    }
    setIsPlaying(isPlaying => !isPlaying)
  }

  return (
    <div className='audio-badge-container' onClick={handleTogglePlay}>
      <span>Listen to audio</span>
      {isPlaying ? (
        <i className='bi bi-volume-mute' />
      ) : (
        <i className='bi bi-volume-up' />
      )}
      <audio id='player' ref={audioRef} preload='metadata'>
        <source src={audioSource} type='audio/mp3' />
      </audio>
    </div>
  )
}

export default AudioBadge
